import { render, staticRenderFns } from "./examManageTop.vue?vue&type=template&id=4f1b7051&scoped=true&"
import script from "./examManageTop.vue?vue&type=script&lang=js&"
export * from "./examManageTop.vue?vue&type=script&lang=js&"
import style0 from "./examManageTop.vue?vue&type=style&index=0&id=4f1b7051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b7051",
  null
  
)

export default component.exports